var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.667 1.892A1.225 1.225 0 0 1 1.892.667h12.215a1.225 1.225 0 0 1 1.226 1.225v12.215a1.225 1.225 0 0 1-1.226 1.226H1.892a1.226 1.226 0 0 1-1.225-1.226zm5.805 4.367h1.986v.997c.287-.573 1.02-1.09 2.122-1.09 2.113 0 2.613 1.143 2.613 3.238v3.881h-2.138V9.881c0-1.193-.286-1.866-1.014-1.866-1.01 0-1.43.726-1.43 1.866v3.404H6.472zm-3.667 6.935h2.14V6.167h-2.14zm2.445-9.32a1.375 1.375 0 1 1-2.75.061 1.375 1.375 0 0 1 2.75-.06",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgLinkedin;